<template>
    <modal
        :active="active"
        :large="true"
        :title="title"
        @closed="$emit('closed', true)"
    >
        <table class="table is-fullwidth">
            <thead>
                <tr>
                    <th class="price">Pris</th>
                    <th class="created-by">Oprettet af</th>
                    <th class="created">Oprettet</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in priceHistory" :key="item.id">
                    <td>{{ item.price_display }}</td>
                    <td>{{ item.created_by }}</td>
                    <td>{{ item.created_at }}</td>
                </tr>
            </tbody>
        </table>

        <template v-slot:footer class="has-space-between">
            <button class="button is-default" @click="$emit('closed', true)">Luk historik</button>
        </template>
    </modal>
</template>

<script>
import Modal from '@elems/modal'

export default {
    components: {
        Modal,
    },
    props: {
        active: Boolean,
        price: Object,
        item: Object
    },
    data() {
        return {
            priceHistory: [],
        }
    },
    computed: {
        title() {
            return 'Pris historik for: ' + (this.price ? this.price.type.name : 'Kostpris');
        },
    },
    watch: {
        active() {
            if (!this.active) {
                this.priceHistory = [];
                return;
            }

            if (this.price) {
                window.axios.get('/api/prices/' + this.price.id + '/history')
                    .then(response => {
                        this.priceHistory = response.data;
                    })
                    .catch(error => console.error(error))
            }

            if (this.item) {
                window.axios.get('/api/items/' + this.item.id + '/cost-price-history')
                    .then(response => {
                        this.priceHistory = response.data;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        }
    }
}
</script>

<style scoped>
    .price {
        width: 60%;
    }
    .created-by {
        width: 20%;
    }
    .created {
        width: 20%;
    }
</style>